module.exports = __webpack_public_path__ + "static/media/ultrasound.cb87ee00.jpg";